export default "__VITE_ASSET__5282a04c__"